import React from 'react';
import { motion } from 'framer-motion';
import { Mountain, Ruler, Radio, Hash } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Stats() {
  const {
    t
  } = useLanguage();
  const stats = [{
    icon: Mountain,
    value: '1 214 ft',
    label: t.stats.elevation
  }, {
    icon: Ruler,
    value: '1 170m',
    label: t.stats.runway
  }, {
    icon: Radio,
    value: '135.580',
    label: t.stats.radio
  }, {
    icon: Hash,
    value: 'LKHV',
    label: t.stats.icao
  }];
  return <section className="w-full bg-[#0f1d35] border-y border-white/5" data-id="element-492" data-mp="207pqefd9m626">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-493" data-mp="205d09excspe1">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12" data-id="element-494" data-mp="255r5yqbhfn8w">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center text-center group" data-id="element-495" data-mp="1qal146o4huh5" data-mpi={index}>
              <div className="mb-4 p-3 bg-[#0a1628] rounded-full border border-white/5 group-hover:border-[#38bdf8]/30 transition-colors" data-id="element-496" data-mp="a5m6s45f0a39">
                <stat.icon className="w-6 h-6 text-[#38bdf8]" data-id="element-497" data-mp="3dlta29jx45bi" />
              </div>
              <span className="text-2xl md:text-3xl font-bold text-white mb-1" data-id="element-498" data-mp="3djqbh14p93v6">
                {stat.value}
              </span>
              <span className="text-sm text-white/50 uppercase tracking-wider font-medium" data-id="element-499" data-mp="3mlprpr7w43x2">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}